import $ from 'jquery';
import { onResize } from '../utils/window';

export default function sidebarSection() {
	const $sidebar = $('#sidebar');
	const $module = $sidebar.children('.module');
	const $body = $sidebar.children('.body');
	const $firstSection = $body.children('.body_section').first();

	if ($module.length > 0 && $firstSection.length > 0) {

		function setHeight() {
			const position = $module.css('position');

			if (position === 'absolute') {
				const height = $module.outerHeight(true);
				$firstSection.css('min-height', height + 'px');
			} else {
				$firstSection.css('min-height', '');
			}
		}

		setHeight();
		onResize(setHeight);
	}
}



// WEBPACK FOOTER //
// ./source/scripts/sections/sidebar.js